module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBold.6f6ad450.woff2";